<div class="white_round padding16 sur_container">
    <div *ngFor="let iRegion of us.currentUser.regions" class="sur_item">
        <app-button-single-line-arrow [withPadding]='false' (click)="editRegion(iRegion)">{{iRegion.name}}</app-button-single-line-arrow>
    </div>
</div>